var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not"},[_vm._v("404")]),_c('div',{staticClass:"word"},[_vm._v("瞎晃悠啥呢，"),_c('a',{attrs:{"href":"/"}},[_vm._v("点击")]),_vm._v("此处回首页干活")])])
}]

export { render, staticRenderFns }